import React from 'react';
import PropTypes from 'prop-types';

import Tag from '@decisiv/ui-components/lib/components/Tag';

/** Which role the user holds in which account. */
export const PERMISSION_ASSIGNMENT = PropTypes.shape({
  account: PropTypes.string,
  /** Present where the caller knows it; account names are not unique. */
  accountId: PropTypes.string,
  permission: PropTypes.string,
});

// Covers the roles the mockups show; anything else falls back to neutral rather
// than guessing a palette design has not specified. Not exported on purpose —
// callers go through roleTag, which is what keeps the two screens in step.
const ROLE_COLORS = {
  'Fleet Administrator': 'fizzyLime',
  'Dealer Administrator': 'warning',
  Member: 'success',
  Manager: 'roseGummy',
};

const NEUTRAL = 'licoriceMousse';

/**
 * A role name as its coloured tag. Shared so the users list's PERMISSIONS cell
 * and the Edit User header cannot drift into two colours for one role.
 *
 * `action` turns it into the design system's divided pill, drawn by KeyDS rather
 * than by CSS of ours — the MGMT. ROLE cell uses it so the tier renders as the
 * same tag it does everywhere else. The accessible name and any aria state
 * belong in `actionAttributes`, which KeyDS spreads onto the element a user
 * actually clicks.
 */
const roleTag = (permission, { action, actionIcon, actionAttributes } = {}) => (
  <Tag
    color={ROLE_COLORS[permission] || NEUTRAL}
    palette="pastel"
    text={permission}
    {...(action ? { action, actionIcon, actionAttributes } : {})}
  />
);

export default roleTag;
